export interface ComplaintFormInitInterface {
  title: string;
  subtitle: string;
  causes: string[];
  comment_placeholder: string;
  cancel_label: string;
  send_label: string;
}

export const complaintFormContent: ComplaintFormInitInterface = {
  title: 'content.complain-title',
  subtitle: 'content.explanation',
  causes: [
    'content.cause1',
    'content.cause2',
    'content.cause3',
    'content.cause4',
    'content.cause5',
    'content.cause6',
    'content.cause7',
    'content.cause8',
    'content.cause9',
    'content.cause10',
    'content.cause11',
    'content.cause12',
    'content.cause13',
  ],
  comment_placeholder: 'content.comments-placeholder',
  cancel_label: 'content.cancel',
  send_label: 'content.send',
};

export const complaintFormUser: ComplaintFormInitInterface = {
  title: 'users.complain-title',
  subtitle: 'users.complain-subtitle',
  causes: ['users.cause1', 'users.cause2', 'users.cause3', 'users.cause4', 'users.cause5', 'users.cause6'],
  comment_placeholder: 'users.comments-placeholder',
  cancel_label: 'users.cancel',
  send_label: 'users.send',
};

export const complaintFormLesson: ComplaintFormInitInterface = {
  title: 'lesson-complain.complain-title',
  subtitle: 'lesson-complain.slide',
  causes: [
    'lesson-complain.cause1',
    'lesson-complain.cause2',
    'lesson-complain.cause3',
    'lesson-complain.cause4',
    'lesson-complain.cause5',
    'lesson-complain.cause6',
    'lesson-complain.cause7',
    'lesson-complain.cause8',
    'lesson-complain.cause9',
    'lesson-complain.cause10',
    'lesson-complain.cause11',
    'lesson-complain.cause12',
    'lesson-complain.cause13',
  ],
  comment_placeholder: 'lesson-complain.comments-placeholder',
  cancel_label: 'lesson-complain.cancel',
  send_label: 'lesson-complain.send',
};
